import {Box} from "@mantine/core";
import React, {PropsWithChildren} from "react";
import styles from "./SectionWrapper.module.css";

interface SectionWrapperProps {
    title: string;
}

/**
 * Generic wrapper that draws a bordered rectangle and overlaps a title on the border,
 * emulating the style requested for settings sections.
 *
 * Usage:
 * <SectionWrapper title="Marketplace"> ...children... </SectionWrapper>
 */
export default function SectionWrapper({title, children}: PropsWithChildren<SectionWrapperProps>) {
    return (
        <Box className={styles.section}>
            <div className={styles.sectionTitle}>{title}</div>
            {children}
        </Box>
    );
}
